var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagIceland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.6045C1.47653 24.0394 3.51684 27.0166 6.26047 29.1246V20.6045H0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 32.3697C15.0669 32.4092 15.5307 32.4306 15.9996 32.4306C23.392 32.4306 29.6124 27.4167 31.4484 20.6045H14.6083V32.3697Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4484 12.2567C29.6124 5.44448 23.392 0.430664 15.9996 0.430664C15.5307 0.430664 15.0669 0.452039 14.6083 0.491539V12.2567H31.4484Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 3.73682C3.51684 5.84494 1.47653 8.822 0.550781 12.2569H6.26047V3.73682Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 14.3438H12.5218H12.5218V0.811035C11.0431 1.13891 9.64131 1.67035 8.34781 2.37616V14.3437H0.135438C0.046375 15.0269 0 15.7234 0 16.4307C0 17.138 0.046375 17.8345 0.135438 18.5177H8.34775H8.34781V30.4852C9.64131 31.191 11.0431 31.7225 12.5218 32.0503V18.5178V18.5177H31.8646C31.9535 17.8345 32 17.138 32 16.4307C32 15.7234 31.9535 15.0269 31.8646 14.3438Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIceland);
export default __webpack_public_path__ + "static/media/flag_iceland.3d3a826f0be47fda7a07b76e46f52f41.svg";
export { ForwardRef as ReactComponent };